import { useState } from 'react';
import { Link } from 'react-router-dom';
import Breadcrumb from '@/components/base/Breadcrumb';
import Pagination from '@/components/base/Pagination';
import { getAllNews } from '@/lib/catalog';
import { usePageMeta } from '@/hooks/usePageMeta';

const PAGE_SIZE = 6;

export default function NewsList() {
  const [page, setPage] = useState(1);
  const allNews = getAllNews();

  usePageMeta({
    title: '神宫寺奈绪最新资讯 - 娱乐动态 | 神宫寺奈绪影视内容站',
    description:
      '汇总神宫寺奈绪最新的娱乐资讯、作品动态与幕后消息，按时间倒序更新，第一时间掌握她的演艺动向。',
    keywords: '神宫寺奈绪资讯,娱乐动态,明星动态,作品新闻',
  });

  const totalPages = Math.max(1, Math.ceil(allNews.length / PAGE_SIZE));
  const currentPage = Math.min(page, totalPages);
  const items = allNews.slice((currentPage - 1) * PAGE_SIZE, currentPage * PAGE_SIZE);

  return (
    <div className="w-full">
      <section className="px-4 md:px-6 pt-8 md:pt-12 pb-6 md:pb-8 bg-background-100 border-b border-background-200">
        <Breadcrumb items={[{ label: '首页', to: '/' }, { label: '资讯' }]} />
        <h1 className="mt-4 font-heading text-2xl md:text-4xl font-bold text-foreground-950">
          资讯动态
        </h1>
        <p className="mt-3 text-sm md:text-base text-foreground-500 max-w-2xl">
          最新娱乐资讯与作品动态，按发布时间倒序排列，带您快速了解神宫寺奈绪的近期动向。
        </p>
      </section>

      <section className="px-4 md:px-6 py-8 md:py-12">
        {items.length > 0 ? (
          <>
            <div className="space-y-4 md:space-y-5">
              {items.map((item) => (
                <Link
                  key={item.id}
                  to={`/news/${item.id}`}
                  className="group flex flex-col sm:flex-row gap-4 p-4 md:p-5 bg-background-50 border border-background-200 rounded-lg hover:border-accent-300 transition-colors cursor-pointer"
                >
                  <div className="w-full sm:w-56 md:w-64 aspect-video sm:aspect-[16/10] rounded-md overflow-hidden bg-background-200 shrink-0">
                    <img
                      src={item.cover}
                      alt={item.title}
                      title={`${item.title} 神宫寺奈绪娱乐资讯`}
                      className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                    />
                  </div>
                  <div className="min-w-0 flex flex-col">
                    <span className="text-xs text-accent-600 font-medium flex items-center gap-1.5">
                      <i className="ri-calendar-line"></i>
                      {item.date}
                    </span>
                    <h2 className="mt-2 text-base md:text-lg font-medium text-foreground-950 group-hover:text-accent-600 transition-colors">
                      {item.title}
                    </h2>
                    <p className="mt-2 text-sm text-foreground-500 line-clamp-2">{item.summary}</p>
                    <span className="mt-auto pt-3 text-sm text-primary-700 flex items-center gap-1.5">
                      阅读全文
                      <i className="ri-arrow-right-line group-hover:translate-x-1 transition-transform"></i>
                    </span>
                  </div>
                </Link>
              ))}
            </div>
            <div className="mt-10">
              <Pagination current={currentPage} total={totalPages} onChange={setPage} />
            </div>
          </>
        ) : (
          <div className="py-16 text-center bg-background-100 border border-background-200 rounded-lg">
            <span className="w-16 h-16 mx-auto rounded-full bg-background-200 text-foreground-400 flex items-center justify-center text-3xl">
              <i className="ri-newspaper-line"></i>
            </span>
            <h3 className="mt-5 font-heading text-lg font-semibold text-foreground-900">暂无资讯</h3>
            <p className="mt-2 text-sm text-foreground-500">目前还没有发布任何资讯内容。</p>
          </div>
        )}
      </section>
    </div>
  );
}